import React from 'react';
import PropTypes from 'prop-types';
import LabelPill from './pill/LabelPill';

const ROLE_LABEL = {
  admin: 'Admin',
  service_manager: 'Service manager',
  engineer: 'Engineer',
};

// A role is what someone is, not how they are doing, so it stays off the severity ramp. The old
// solid fills said otherwise — an Engineer was rendered in the same orange as a degraded
// integration.
export default function UserRoleBadge({ role, className }) {
  return (
    <LabelPill className={className}>
      {ROLE_LABEL[role] || 'Unknown'}
    </LabelPill>
  );
}

UserRoleBadge.propTypes = {
  role: PropTypes.string,
  className: PropTypes.string,
};

UserRoleBadge.defaultProps = {
  role: null,
  className: '',
};
